module.exports = __webpack_public_path__ + "img/V7.f7e37396.png";